export enum EActionTypes {
  GET_DATA = 'GET_DATA',
}
